module.exports = __webpack_public_path__ + "img/tip_vip.0b31ed10.png";